import { Alert, Typography } from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import { formatCurrency } from "../../../utils/formatCurrency";

const NewFeeInformation = ({ state }) => {
  const title = "Aviso Importante: Cambio en tu Prima de Seguro";
  const subtitle = "Revisa la información antes de tomar una decisión";

  return (
    <>
      <TitleHeaders title={title} subtitle={subtitle} />

      <Alert severity="warning" sx={{ marginBottom: 2 }}>
        <Typography variant="h6" gutterBottom>
          {`Importante: Hemos hecho una cotización para tu vehículo ${state.product}.`}
        </Typography>
        <Typography variant="body1" color="#000" gutterBottom>
          {`Si decides volver a contratar, el precio de tu póliza será más alto.`}
        </Typography>
        <Typography variant="body1" color="#000" gutterBottom>
          Pasarías de pagar{" "}
          <strong>{`${formatCurrency(state.currenPremium)}`}</strong> a {" "}
          <strong>{`${formatCurrency(state.newPremium)}`}</strong> {" "}
          de manera {state.period}.
        </Typography>
        <Typography variant="body1">
          Esto incluye las coberturas extras que tienes contratadas.
        </Typography>
      </Alert>

      <Typography variant="h6" color="#000" sx={{ marginTop: 2 }}>
        {`¿Estás seguro de que quieres perder tu prima actual? 🤨`}
      </Typography>
    </>
  );
};

export default NewFeeInformation;
